export const codeComposingComponents = `<Box padding="space.200">
  <p>You have unread messages</p>
  <Button appearance="primary">
    Read messages <Badge appearance="primaryInverted">{5}</Badge>
  </Button>
</Box>`;

export const codeRecommended = `const wrapperStyles = xcss({
  background: 'color.background.accent.blue.bolder',
});
const textStyles = css({
  color: token('color.text.inverse'),
});
const selectedTextStyles = css({
  textDecoration: 'underline',
});
export const Component = (props) => (
  <Box padding="space.100" xcss={wrapperStyles}>
    <span css={[textStyles, props.selected && selectedTextStyles]}>
      Hello world
    </span>
  </Box>
);`;

export const codeBadExample1 = `// shared/styles.ts
export default styled.div<any>\`
  padding: 8px;
  background: #0C66E4;
  > span {
    color: #fff;
    \${props => props.selected && 'text-decoration: underline !important'}
  }`;

export const codeBadExample2 = `// component.ts
import Wrapper from '../shared/styles.ts';
export const Component = (props) => (
  <Wrapper selected={props.selected}>
    <span>Hello world</span>
  </Wrapper>
);`;
